<template>
    <div class="modal-card">
        <alert-container :messages="msgs"/>
        <section class="modal-card-body modal-es">
            <!-- CABEÇALHO MODAL -->
            <div class="listing-header">
                <div class="title-breadcrumb">
                    <h1 class="title">
                        {{$t('periodo')}}: {{periodo.idperiodo ? periodoTitle : $t('novo-periodo')}}
                    </h1>
                </div>
                <div class="header-buttons">
                    <button 
                        class="delete-btn" 
                        type="button" 
                        @click="onFecharModal()" 
                        :disabled="isPeriodoSaving">
                        {{ $t('cancelar') }}
                    </button>
                    <button 
                        class="save-btn" 
                        type="button"
                        @click="savePeriodo()" 
                        :disabled="isPeriodoSaving">
                            {{ $t('salvar') }}
                        <svg 
                            class="svg-loader" 
                            v-if="isPeriodoSaving">
                            <use :xlink:href="require('@/assets/img/icons/loader.svg')+'#layer'"></use>
                        </svg>
                    </button>
                </div>
            </div>

            <!-- CAMPOS DESCRIÇÃO + DIA -->
            <div 
                class="columns content" 
                v-if="periodo.idperiodo">
                <div class="column is-three-quarters">
                    <v-input
                        ref="periodoDescricaoInput"
                        title="descricao"
                        v-model="periodo.descricao"
                        :disabled="isPeriodoSaving"
                        :maxlength="255"
                    />
                </div>
                <div class="column is-one-quarter">
                    <label v-text="$t('dia')"/>
                    <s-select
                        v-model="periodo.dia"
                        :options="['1', '2', '3', '4', '5', '6', '7']"
                        :selectHeight="36"
                        :disabled="isPeriodoSaving"
                        :tooltip="false"
                    >
                        <template v-slot:selected="v">
                            {{ $t(getLabelWeekday(v.option)) }}
                        </template>
                        <template v-slot:option="v">
                            {{ $t(getLabelWeekday(v.option)) }}
                        </template>
                    </s-select>
                </div>
            </div>

            <div class="columns is-multiline content" v-else>
                <div class="column is-full">
                    <vms-select
                        ref="diasInput"
                        label="nome"
                        title="dias"
                        v-model="novoPeriodoDias"
                        :options="['1', '2', '3', '4', '5', '6', '7']"
                        :invalid="novoPeriodoDias.length == 0"
                        @input="orderDays"
                    >
                        <template 
                            slot="option" 
                            slot-scope="option">
                            {{ $t(getLabelWeekday(option.bind.nome)) }}
                        </template>
                        <template 
                            slot="selected-option" 
                            slot-scope="option">
                            {{ $t(getLabelWeekday(option.bind.nome)) }}
                        </template>
                    </vms-select>
                </div>
                <div class="column is-full">
                    <v-input
                        ref="periodoDescricaoInput"
                        title="descricao"
                        v-model="periodo.descricao"
                        :disabled="isPeriodoSaving"
                        :maxlength="255"
                    />
                </div>
            </div>

            <!-- HORÁRIOS -->
            <div class="columns is-multiline horarios">
                <div 
                    class="column is-half" 
                    v-for="(e, i) in periodo.entradassaidas" 
                    :key="i">
                    <div class="columns is-mobile">
                        <div class="column is-one-third is-flex label-tipo">
                            <span>{{ e.tipo == 'ENTRADA' ? $t('entrada') : $t('saida') }}:</span>
                        </div>
                        <div class="column is-two-thirds is-flex with-del-btn">
                            <v-mask
                                class="hour"
                                ref="horarioInput"
                                title="horario"
                                v-model="e.horario"
                                :msg="e.horario != '' ? 'msg-horario-invalido' : 'msg-campo-obrigatorio'"
                                :mask="['##:##']"
                                :invalid="validateTime(e.horario)"
                                :disabled="isPeriodoSaving"
                                masked
                            />
                            <!--    length > 2 pq o array é um item por entrada e saída, e o botão de exclusão deve aparecer somente
                                    quando há mais de um par; @68170 -->
                            <button 
                                class="btn exclude-btn" 
                                v-if="i % 2 == 1 && periodo.entradassaidas.length > 2" 
                                @click="delES(i)" 
                                :disabled="isPeriodoSaving">
                                <svg class="svg-icons">
                                    <use :xlink:href="require('@/assets/img/icons/delete.svg')+'#layer'"></use>
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- BOTÃO ADD ENTRADA SAÍDA -->
            <div class="columns">
                <div class="column is-full is-flex add-es">
                    <button 
                        class="save-btn" 
                        type="button" 
                        v-if="periodo.entradassaidas && periodo.entradassaidas.length < 6" 
                        @click="addES" 
                        :disabled="isPeriodoSaving">
                        {{ $t('add-entrada-saida') }}
                    </button>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
// COMPONENTS


import PeriodoService from "@/services/promotor/PeriodoService";

// MENSAGENS
import Message from "@/models/Message";

export default {
    props: {
        idperiodo: 0,
    },
    data() {
        return {
            periodo: {},
            novoPeriodoDias: [],
            periodoTitle: '',
            isPeriodoSaving: false,
            periodoService: new PeriodoService(this.$http, this.$router),
            msgs: [],
        }
    },
    created() {
        if (this.idperiodo && this.idperiodo > 0) {
            this.openPeriodo();
        } else {
            this.resetPeriodo();
        }
    },
    methods: {
        resetPeriodo(){
            this.periodo = {
                descricao: '',
                idturno: this.id,
                entradassaidas: [
                    { tipo: 'ENTRADA', horario: '' },
                    { tipo: 'SAIDA', horario: '' }
                ]
            }
            this.novoPeriodoDias = [];
        },
        openPeriodo() {
            this.periodoLoading = this.idperiodo;

            this.periodoService.find(this.idperiodo)
                .then(r => {
                    if (r.status == 200) {
                        this.periodo = r.content;
                        this.periodoTitle = r.content.descricao;
                        return;
                    }

                    this.msgs.push(new Message("error", "msg-erro-load-periodo", true));
                })
                .catch(e => {
                    this.msgs.push(new Message("error", "msg-erro-load-periodo", true));
                })
                .finally(_ => {
                    this.periodoLoading = -1;
                });
        },
        getLabelWeekday(day) {
            switch (day) {
                case "1":
                    return 'segunda';
                case "2":
                    return 'terca';
                case "3":
                    return 'quarta';
                case "4":
                    return 'quinta';
                case "5":
                    return 'sexta';
                case "6":
                    return 'sabado';
                case "7":
                    return 'domingo';
                default:
                    return 'invalido';
            }
        },
        validatePeriodo(novo = false) {
            /*  Validações:
                 1. Existe ao menos um horário
                 2. Se os horários foram escritos corretamente
                 3. Se o de entrada não começa depois do de saída 
                 4. Se os horários não se sobrepoem uns aos outros */
            let valid = true;

            if (novo && this.novoPeriodoDias.length == 0) {
                console.error('[PERIODO] Não existem dias selecionados.');
                this.msgs.push(new Message("error", "msg-erro-sem-dia", true));
                return false;
            }

            // Validação #1
            if (!this.periodo.entradassaidas.length) {
                console.error('[PERIODO] Não existem horários');
                this.msgs.push(new Message("error", "msg-erro-sem-horarios", true));
                return false;
            }

            // Validação #2
            let invalidtimes = this.periodo.entradassaidas.some(e => {
                return this.validateTime(e.horario);
            });

            if (invalidtimes) {
                console.error('[PERIODO] Há horários inválidos');
                this.msgs.push(new Message("error", "msg-erro-horarios-invalidos", true));

                this.$refs.horarioInput.forEach(e => {
                    e.focusedOut = true;
                });

                return false;
            }

            // Validação #3
            this.periodo.entradassaidas.forEach((e, i, a) => {
                if (e.tipo == 'ENTRADA') {
                    // Se for do tipo entrada, o próximo do array tem que ser saída
                    let entrada = this.$moment(e.horario, "HH:mm");
                    let saida = this.$moment(a[i + 1].horario, "HH:mm");

                    // Diff returna número de ms entre os dois moments
                    // Maior que zero, o primeiro está depois do segundo no tempo, menor caso contrário, zero se iguais
                    if (saida.diff(entrada) <= 0) {
                        console.error(`[PERIODO] O horário de entrada [${e.horario}] não é anterior ao horário de saída [${a[i + 1].horario}]`);
                        this.msgs.push(new Message("error", "msg-erro-horario-entrada-menor-saida", true));
                        valid = false;
                    }
                }
            });

            if (!valid) { return false; }

            // Validação #4
            if (this.periodo.entradassaidas && this.periodo.entradassaidas.length == 4) {
                // Com dois períodos de entrada e saída, verifica P1 com P2
                let es = this.periodo.entradassaidas;
                let p1 = this.$moment.range(this.$moment(es[0].horario, "HH:mm"), this.$moment(es[1].horario, "HH:mm")); // Primeiro par de horários
                let p2 = this.$moment.range(this.$moment(es[2].horario, "HH:mm"), this.$moment(es[3].horario, "HH:mm")); // Segundo par de horários

                if (p1.overlaps(p2)) {
                    console.error('[PERIODO] Há sobreposição de horários');
                    this.msgs.push(new Message("error", "msg-erro-horario-sobreposicao", true));
                    valid = false;
                }
            } else if (this.periodo.entradassaidas && this.periodo.entradassaidas.length == 6) {
                // Com três períodos de entrada e saída, verifica (P1, P2), (P1, P3) e (P2, P3)
                // Se houver sobreposição em qualquer um dos três casos, é inválido
                let es = this.periodo.entradassaidas;
                let p1 = this.$moment.range(this.$moment(es[0].horario, "HH:mm"), this.$moment(es[1].horario, "HH:mm")); // Primeiro par de horários
                let p2 = this.$moment.range(this.$moment(es[2].horario, "HH:mm"), this.$moment(es[3].horario, "HH:mm")); // Segundo par de horários
                let p3 = this.$moment.range(this.$moment(es[4].horario, "HH:mm"), this.$moment(es[5].horario, "HH:mm")); // Teceiro par de horários

                if (p1.overlaps(p2) || p1.overlaps(p3) || p2.overlaps(p3)) {
                    console.error('[PERIODO] Há sobreposição de horários');
                    this.msgs.push(new Message("error", "msg-erro-horario-sobreposicao", true));
                    valid = false;
                }
            }

            return valid;
        },
        addES() {
            let es = [
                { tipo: 'ENTRADA', horario: '' },
                { tipo: 'SAIDA', horario: '' },
            ];

            this.periodo.entradassaidas = [...this.periodo.entradassaidas, ...es];
        },
        delES(idx) {
            let start = idx % 2 ? idx - 1 : idx;
            this.periodo.entradassaidas.splice(start, 2);
        },
        validateTime(time) {
            return time.length < 5 ? true : !this.$moment(time, 'HH:mm')._isValid;
        },
        orderDays() {
            this.novoPeriodoDias = this.novoPeriodoDias.sort();
        },
        savePeriodo() {
            if (this.validatePeriodo()) {
                this.periodo = this.mapTosave(this.periodo);
                this.periodo.dias = this.novoPeriodoDias;
                this.periodo.idturno = this.$route.params.id;

                this.isPeriodoSaving = true;

                this.periodoService.save(this.periodo)
                    .then((r) => {
                        if (r.status == 200) {
                            this.modalPeriodoOpen = false;
                            this.msgs.push(new Message("success", "msg-success-save-periodo", true));
                            this.onFecharModal()
                        } else {
                            this.msgs.push(new Message("error", r.message, true));
                        }
                    })
                    .catch((e) => {
                        let error = "msg-erro-salvar-turnos";
                        if (e && e.status == 500) {
                            error = e.message;
                        }
                        this.msgs.push(new Message("error", error, true));
                    })
                    .finally(_ => {
                        this.isPeriodoSaving = false;
                    });
            }
        },
        onFecharModal() {
            setTimeout(() => {
                this.$emit('fecharModal', true);
            }, 500);
        },
    },
}
</script>


<style lang="scss" scoped>
@import "./mixins.scss";

.column {
    @include default-size-column;
}

#main {
    display: flex;
    flex-direction: column;
    padding: 0 20px;
    height: auto;
    min-height: 100%;

    .page {
        position: relative;

        .turno-header {
            padding-top: 1rem;
            padding-bottom: 0.5rem;

            .column {
                padding: 0.25rem 0.75rem;
            }
        }
    }

    .excluir-field .svg-loader {
        margin-left: 0;
    }

    .btn {
        min-height: 30px;
    }

    .periodos-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-top: 1.25rem;
        padding-right: 1.25rem;
        padding-bottom: 0.75rem;
        padding-left: 0.75rem;

        h1.title.mid {
            padding-bottom: 0;
            margin-right: 0;
        }

        button {
            padding: 10px;
        }
    }

    .modal-es {
        border-radius: 3px;

        .content {
            margin-top: 0px;
        }

        .horarios {
            min-height: 140px;

            .label-tipo {
                align-items: center;
                color: $dark-gray-color;
                font-weight: 600;

                span {
                    margin-top: 1.25rem;
                }
            }
        }

        .add-es {
            justify-content: center;
        }

        .with-del-btn {
            .exclude-btn {
                margin-top: 1.5rem;
                margin-left: 1rem;
            }

            .hour {
                width: 100%;
            }
        }

        button.save-btn,
        button.delete-btn {
            display: flex;
            align-items: center;
            justify-content: center;
            min-height: 45px;
            padding: 0 15px;
        }
    }
}
</style>